import '@vaadin/text-field';
import '@vaadin/icons';
import '@vaadin/icon';

import { componentName, TextFieldClass } from './TextFieldClass';

customElements.define(componentName, TextFieldClass);

export { TextFieldClass, componentName };
